import { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

import { IconColor, useIconColor } from './useIconColor';

interface SVGRProps {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
  color?: IconColor;
}

export const ArenaAlt = ({
  title,
  titleId,
  size = 2,
  color,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & SVGRProps) => {
  const { fill, svgNode } = useIconColor(color);
  return (
    <svg
      viewBox="0 0 37 36"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4429 17.8705H7.88176L11.5418 27.0207L15.2037 17.8705L10.4555 6H16.3908L18.2658 10.6875L20.1408 6H26.076L21.3278 17.8705H21.317L24.9771 27.0207L28.6372 17.8705H25.076L29.8242 6H35.7595L31.0113 17.8705H34.5724L29.8242 29.741H20.13L18.2595 25.0648L16.389 29.741H6.69471L1.94651 17.8705H5.50766L0.75946 6H6.69471L11.4429 17.8705Z"
        fill={fill}
      />
      {svgNode}
    </svg>
  );
};
